// Settings.js
import React, { useState } from "react";
import "./Settings.css";

import GeneralSettings from "./GeneralSettings/GeneralSettings";
import UserSettings from "./UserSettings/UserSettings";
import TeamSettings from "./TeamSettings/TeamSettings";
import UserManagement from "./UserManagement/UserManagement";
import BillingManagement from "./BillingManagement/BillingManagement";
import { useAuthStore } from "../../services/useAuthStore";



const Settings = () => {
  const [section, setSection] = useState("user");
  const membership = useAuthStore((s) => s.membership);

  // Verificar se o usuário é ADMIN
  const isAdmin = membership?.role === "admin";

  return (
    <div className="Configuracoes">
      <header className="co-header">
        <div>
          <p className="co-kicker">Configurações do FASTEAM</p>
          <h1 className="co-title">Central de ajustes, permissões e integrações</h1>
          <p className="co-subtitle">
            Defina como o FASTEAM se comporta em todas as telas: Dashboard,
            Automação de Atendimento, Tarefas, Fluxos Inteligentes, WhatsApp,
            Operações de Equipe, Relatórios e Integrações. Inclui opções avançadas
            que apenas o admin vê.
          </p>
        </div>
      </header>

      <section className="co-main">
        <aside className="co-sidebar">
          <h2 className="co-sidebar-title">Itens do menu</h2>

          <nav className="co-menu">
            {/* <button
              className={
                section === "general"
                  ? "co-menu-item co-menu-item-active"
                  : "co-menu-item"
              }
              onClick={() => setSection("general")}
            >
              Geral (idioma & fuso horário)
            </button> */}

            <button
              className={
                section === "user"
                  ? "co-menu-item co-menu-item-active"
                  : "co-menu-item"
              }
              onClick={() => setSection("user")}
            >
              Perfil do usuário
            </button>
                <button
                  className={
                    section === "users"
                      ? "co-menu-item co-menu-item-active"
                      : "co-menu-item"
                  }
                  onClick={() => setSection("users")}
                >
                  Gerenciamento de Usuários
                </button>

                <button
                  className={
                    section === "billing"
                      ? "co-menu-item co-menu-item-active"
                      : "co-menu-item"
                  }
                  onClick={() => setSection("billing")}
                >
                  Faturamento & Assinatura
                </button>

            {/* Apenas ADMIN pode ver estas opções */}
            {/* {isAdmin && ( */}
              <>
                <button
                  className={
                    section === "team"
                      ? "co-menu-item co-menu-item-active"
                      : "co-menu-item"
                  }
                  onClick={() => setSection("team")}
                >
                  Equipe & permissões
                </button>


              </>
            {/* )} */}




          </nav>

          <div className="co-sidebar-note">
            <p>
              <strong>Suporte:</strong> se tiver alguma dúvida entre em contato no numero 48 99177 1777.
            </p>
          </div>
        </aside>

        <div className="co-panel">
          {/* {section === "general" && <GeneralSettings />} */}
          {section === "user" && <UserSettings />}
          {section === "team" && <TeamSettings />}
          {/* Apenas ADMIN pode acessar estas seções */}
          {/* {isAdmin && section === "team" && <TeamSettings />} */}
          
          {isAdmin && section === "users" && <UserManagement />}
          {isAdmin && section === "billing" && <BillingManagement />}
        </div>
      </section>
    </div>
  );
};

export default Settings;
